import React from 'react';
import { Box } from '@mui/material';

export function CenteredBox({ children, sx }) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      width={"100%"}
      maxWidth={"800px"}
      gap={4}
      sx={{...sx}}
    >
      {children}
    </Box>
  );
}
